import React, { Component } from 'react';
import { Col, Row } from 'react-grid-system';

import { inject, observer } from 'mobx-react';
import { BIG_NUMBERS } from 'modules/userManager/constants';
import PropTypes from 'prop-types';

import BigNumberCard from './BigNumberCard';
import BigNumbersFormat from './BigNumbersFormat';

import './BigNumbersSection.scss';

@inject((stores) => ({ aggregations: stores.UserManagerStore.aggregations }))
@observer
class BigNumbersSection extends Component {
  static propTypes = {
    aggregations: PropTypes.object,
    t: PropTypes.func
  };

  get bigNumbersList() {
    return Object.keys(BIG_NUMBERS)
      .map((key) => {
        const bigNumber = this.getBigNumber(key);

        return bigNumber && BigNumbersFormat.formatBigNumber(bigNumber);
      })
      .filter((bigNumber) => bigNumber);
  }

  getBigNumber = (key) => {
    const { aggregations } = this.props;

    const { type } = BIG_NUMBERS[key];
    const bigNumberData = aggregations[type];
    const isBigNumberValid =
      bigNumberData && typeof bigNumberData.value !== 'undefined';

    return isBigNumberValid ? { ...bigNumberData, ...BIG_NUMBERS[key] } : null;
  };

  renderColumn = (bigNumber) => (
    <Col xs={6} md={3} className="big-numbers__section__card-container">
      <BigNumberCard {...bigNumber} />
    </Col>
  );

  render() {
    return (
      this.bigNumbersList.length > 0 && (
        <div className="big-numbers__section__container">
          <Row nogutter>{this.bigNumbersList.map(this.renderColumn)}</Row>
        </div>
      )
    );
  }
}

export default BigNumbersSection;
